const ShareIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        {...props}
    >
        <path d="M9.667 8.482c-.465 0-.88.18-1.198.464l-4.357-2.5c.03-.139.055-.277.055-.422 0-.144-.025-.283-.055-.422L8.42 3.127c.33.3.764.487 1.247.487A1.818 1.818 0 0 0 11.5 1.807C11.5.807 10.681 0 9.667 0a1.818 1.818 0 0 0-1.834 1.807c0 .145.025.283.055.422L3.58 4.705a1.84 1.84 0 0 0-1.247-.488A1.818 1.818 0 0 0 .5 6.024c0 1 .819 1.807 1.833 1.807a1.84 1.84 0 0 0 1.247-.488L7.931 9.85c-.03.127-.049.26-.049.392 0 .97.8 1.759 1.785 1.759.984 0 1.784-.79 1.784-1.759 0-.97-.8-1.76-1.784-1.76Zm0-7.277c.336 0 .61.27.61.602a.609.609 0 0 1-.61.603.609.609 0 0 1-.611-.603c0-.331.275-.602.61-.602ZM2.333 6.627a.609.609 0 0 1-.61-.603c0-.331.274-.602.61-.602.336 0 .611.27.611.602a.609.609 0 0 1-.61.603Zm7.334 4.228a.609.609 0 0 1-.611-.602c0-.331.275-.602.61-.602.337 0 .612.27.612.602a.609.609 0 0 1-.611.602Z" />
    </svg>
);

export default ShareIcon;
